export default "__VITE_ASSET__CAiED9wM__"